// extracted by mini-css-extract-plugin
export var checkbox = "_9d-0";
export var circle = "_9d-3";
export var horizontalContainer = "_9d-7";
export var sm = "_9d-5";
export var switch0 = "_9d-2";
export var switchDisabled = "_9d-8";
export var switchEnabled = "_9d-1";
export var textSwitchContainer = "_9d-9";
export var textSwitchOption = "_9d-a";
export var textSwitchOptionSelected = "_9d-b";
export var verticalContainer = "_9d-6";
export var xs = "_9d-4";